// mobile nav
const burger = document.getElementById('burger');
const navLinks = document.getElementById('navLinks');
burger.addEventListener('click', () => {
  burger.classList.toggle('open');
  navLinks.classList.toggle('open');
});
navLinks.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
  burger.classList.remove('open'); navLinks.classList.remove('open');
}));

// faq accordion
document.querySelectorAll('.faq-item').forEach(item => {
  const q = item.querySelector('.faq-q');
  const a = item.querySelector('.faq-a');
  if(item.classList.contains('open')){ a.style.maxHeight = a.scrollHeight + 'px'; }
  q.addEventListener('click', () => {
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(other => {
      other.classList.remove('open');
      other.querySelector('.faq-a').style.maxHeight = 0;
    });
    if(!isOpen){
      item.classList.add('open');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  });
});

// reveal on scroll
const revealEls = document.querySelectorAll('.reveal');
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
}, {threshold:0.12});
revealEls.forEach(el => io.observe(el));

// ---- ajout au panier (AJAX Shopify) ----
function showCartToast(message, isError){
  let toast = document.getElementById('cartToast');
  if(!toast){
    toast = document.createElement('div');
    toast.id = 'cartToast';
    toast.className = 'cart-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.classList.toggle('error', !!isError);
  toast.classList.add('show');
  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => toast.classList.remove('show'), 3200);
}

function updateCartCount(count){
  document.querySelectorAll('.nav-cart-count').forEach(el => {
    el.textContent = count;
    el.classList.toggle('has-items', count > 0);
  });
}

document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const variantId = btn.getAttribute('data-variant-id');
    const title = btn.getAttribute('data-product-title') || 'Produit';
    if(!variantId){
      showCartToast("Ce produit n'est pas disponible pour le moment.", true);
      return;
    }
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if(!ok){ throw new Error(data && data.description ? data.description : 'Erreur ajout panier'); }
        return fetch('/cart.js').then(r => r.json());
      })
      .then(cart => {
        updateCartCount(cart.item_count);
        showCartToast(title + ' ajouté au panier ✓');
      })
      .catch(err => {
        showCartToast("Impossible d'ajouter au panier. Réessayez.", true);
        console.error(err);
      })
      .finally(() => {
        btn.disabled = false;
        btn.classList.remove('loading');
        btn.innerHTML = originalHTML;
      });
  });
});
